<template>
  <div>
    <div class="divText">
        <div @click="tapBtn()">{{this.taptext||'请选择'}}</div>
    </div>
    <div @click.stop>
    <div v-if="this.tapshow" class="tapdivShow">
        <div v-for="item in options_" :key="item.id">
            <div @click="onSelect(item.id,item.text)">{{item.text}}</div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
  import { Button, Popover } from 'vant'

  export default {
    name: 'RemotePicker',
    components: {
      [Button.name]: Button,
      [Popover.name]: Popover
    },
    props: {
      className: String,
      options: Array,
      selectFirst: {
        type: Boolean,
        default: false
      },
      removeSet: Set,
      usingCode: Boolean
    },
    data () {
      return {
        show: false,
        tapshow: false,
        taptext: ''
      }
    },
    created () {
      if (this.options) return
      this.$store.dispatch('data/kvList', this.className)
    },

mounted () {
      const that = this
      document.addEventListener('click', (e) => {
          if (!that.$el.contains(e.target)) {
              this.tapshow = false
          }
      })
    },
    methods: {
      onSelect (id, text) {
        this.taptext = text
        this.$emit('input', id)
        this.tapshow = false
      },
      tapBtn () {
          if (this.tapshow) this.tapshow = false
          else this.tapshow = true
      }
    },
    computed: {
      options_ () {
        if (this.options) return this.options

        const options = []
        for (const item of this.$store.state.data[this.className] || []) {
          if (this.removeSet && this.removeSet.has(item.id)) continue

          options.push({
            id: item.id,
            text: item.name
          })
        }
        return options
      }
    }
  }
</script>

<style>
.divText{
position:relative;
padding: 0px 10px;border: 1px solid #8CC4FD;
height: 30px;
line-height: 30px;
color: #5ca7f3;
font-size: 14px;
}
.tapdivShow{
    position: absolute;
    z-index: 999;
    background-color: white;
    text-align: center;
    padding: 0px 10px;
}
</style>
